module.exports = __webpack_public_path__ + "static/media/wf.307d300a.svg";